import React, { ChangeEvent } from 'react'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Input, Select } from '@node-space/storybook-components'
import { AddBankAcountFormPayload } from 'types/paymentMethod'

export interface NgnBankFormProps {
  formValues?: AddBankAcountFormPayload
  errors?: FieldErrors<AddBankAcountFormPayload>
  bankListOptions: { label: string; value: string }[]
  register: UseFormRegister<AddBankAcountFormPayload>
  handleChange: (e: ChangeEvent<HTMLInputElement>, field: string) => void
  handleSelectChange: (value: string, field: string) => void
}

export const NGN = (props: NgnBankFormProps) => {
  const { t } = useTranslation()
  const { formValues, errors, bankListOptions, register, handleChange, handleSelectChange } = props

  return (
    <>
      <Select
        {...register('bankCode')}
        label={t('bank')}
        placeholder={t('selectYourBank')}
        value={formValues?.bankCode}
        error={!!errors?.bankCode}
        errorText={errors?.bankCode?.message}
        onChange={value => handleSelectChange(value, 'bankCode')}
        options={bankListOptions}
        isSearchable={true}
      />
      <Input
        {...register('description')}
        type="text"
        inputMode="text"
        label={t('description')}
        error={!!errors?.description}
        errorText={errors?.description?.message}
        placeholder={t('bankNamePlaceholder')}
        value={formValues?.description}
        onChange={e => handleChange(e, 'description')}
      />
      <Input
        {...register('ngnAccountNumber')}
        type="text"
        inputMode="text"
        label={t('accountNumber')}
        error={!!errors?.ngnAccountNumber}
        errorText={errors?.ngnAccountNumber?.message}
        placeholder={t('accountNumber')}
        value={formValues?.ngnAccountNumber}
        onChange={e => handleChange(e, 'ngnAccountNumber')}
      />
    </>
  )
}
